'use client';

import React, { FC, PropsWithChildren } from 'react';
import { cn } from './cn';

// A rounded box with a black border and an offset "hard" drop-shadow in a brand accent color — the
// same treatment as the orange/coral buttons. This owns only the border + shadow + background;
// layout (padding, flex, alignment, corner radius) is left to the caller via className.
export const ShadowBox: FC<
  PropsWithChildren<{
    color?: 'orange' | 'coral';
    className?: string;
  }>
> = ({ color = 'orange', className, children }) => {
  return (
    <div
      className={cn(
        'rounded-2xl border-3 border-black bg-white',
        color === 'orange'
          ? 'shadow-[3px_4px_0px_0px_var(--orange-600),3px_4px_0px_2px_var(--black)]'
          : 'shadow-[3px_4px_0px_0px_var(--coral-600),3px_4px_0px_2px_var(--black)]',
        className
      )}
    >
      {children}
    </div>
  );
};
